module.exports = __webpack_public_path__ + "static/media/Jelly Rolls.8b8c4da0.jpg";